import { configureStore } from '@reduxjs/toolkit';
import { authApi } from '../features/user/authApi';
import { panApi } from '../features/panCard/panApi';
import { leadApi } from '../features/leads/leadApi';
import { approveApi } from '../features/approval/approveApi';
import { loanApi } from '../features/loan/loanApi';
import { collectionApi } from '../features/collection/collectionApi';

import authReducer from '../features/user/authSlice';
import panLookupReducer from '../features/panCard/panSlice';
import leadSliceReducer from '../features/leads/leadSlice';
import approveSliceReducer from '../features/approval/approveSlice';
import collectionSliceReducer from '../features/collection/collectionSlice';
import loanSliceReducer from '../features/loan/loanSlice';
import orgReportSliceReducer from '../features/reports/orgReportSlice';
import { orgReportApi } from '../features/reports/orgReportApi';







export const store = configureStore({
  reducer: {
    auth: authReducer,
    pan: panLookupReducer,
    leads: leadSliceReducer,
    approve: approveSliceReducer,
    collection: collectionSliceReducer,
    loan: loanSliceReducer,
    orgReport: orgReportSliceReducer,





    [authApi.reducerPath]: authApi.reducer,
    [panApi.reducerPath]: panApi.reducer,
    [leadApi.reducerPath]: leadApi.reducer,
    [approveApi.reducerPath]: approveApi.reducer,
    [collectionApi.reducerPath]: collectionApi.reducer,
    [loanApi.reducerPath]: loanApi.reducer,
    [orgReportApi.reducerPath]: orgReportApi.reducer,




  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware)
    .concat(panApi.middleware)
    .concat(leadApi.middleware)
    .concat(approveApi.middleware)
    .concat(collectionApi.middleware)
    .concat(loanApi.middleware)
    .concat(orgReportApi.middleware)





});
